module.exports = __webpack_public_path__ + "static/media/Pared.fe514e1a.jpg";